import { render, staticRenderFns } from "./EmailLists.vue?vue&type=template&id=1182b92e&scoped=true"
import script from "./EmailLists.vue?vue&type=script&lang=js"
export * from "./EmailLists.vue?vue&type=script&lang=js"
import style0 from "./EmailLists.vue?vue&type=style&index=0&id=1182b92e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1182b92e",
  null
  
)

export default component.exports